<template>
  <div id="coupons">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateForm = null;
                mediaDialog = true;
              "
              v-if="true"
            >
              {{ $t("contentManagement.eventAlbum.gallery.addMedia") }}
            </el-button>
            <el-button icon="fas fa-plus" type="primary" size="small" v-else disabled round>
              {{ $t("contentManagement.eventAlbum.gallery.addMedia") }}
            </el-button>
            
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("contentManagement.eventAlbum.gallery.gallery") }}</h5>
              <span v-if="$store.state.eventalbum.items.length > 0" v-html="$t('totalContent', [$store.state.eventalbum.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refresh()" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="card-body" v-if="false">
            <upgrade-overlay height="200px"></upgrade-overlay>
          </div>
          <div class="card-body" v-else-if="$store.state.eventalbum.items.length > 0">
            <draggable :list="$store.state.eventalbum.items" tag="div" handle=".el-icon-s-grid" draggable=".item" class="albums-container" v-bind="dragOptions" @start="dragList = true" @end="changeSort">
              <div class="item" v-for="(item, index) in $store.state.eventalbum.items" :key="item.id + index" :class="item.isActive ? '' : 'passive'">
                <div class="album-drag">
                  <span><i :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i></span>
                  <span
                    class="album-edit"
                    @click="
                      updateForm = item.id;
                      mediaDialog = true;
                    "
                  >
                    <i class="fas fa-pen"></i>
                  </span>
                </div>
                <div class="album-content">
                  <iframe v-if="item.type == 1" :src="'https://www.youtube.com/embed/' + createYoutubeUrl(item.url)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  <div v-if="item.type == 0" class="img" :style="'background-image:url(' + $imageus + item.url + '?width=257&height=212&mode=cover)'"></div>
                </div>
                <div class="bottom">
                  <div class="album-title">{{ item.title }}</div>
                </div>
              </div>

              <div
                class="item-2"
                @click="
                  updateForm = null;
                  mediaDialog = true;
                "
              >
                <div class="empty-content">
                  <span>{{ $t("contentManagement.eventAlbum.gallery.addMediaForAlbum") }}</span>
                  <div class="empty-icon">
                    <i class="fas fa-plus"></i>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-gallery-lottie'"
              :title="$t('contentManagement.eventAlbum.gallery.gallery')"
              @btnAdd="
                updateForm = null;
                mediaDialog = true;
              "
              @btnRefresh="refresh()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>
          <div class="card-footer" v-if="true"></div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="mediaDialog" :close-on-click-modal="false" :title="updateForm ? $t('contentManagement.eventAlbum.gallery.addMediaForAlbum') : $t('contentManagement.eventAlbum.gallery.addMediaForAlbum')" class="medium" center modal-append-to-body destroy-on-close>
      <MediaAddUpdate @closeDialog="mediaDialog = false" :id="updateForm" v-if="mediaDialog" typeMedia="album" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ExcelImport from "../../components/ExcelImport";
import MediaAddUpdate from "../../components/MediaAddUpdate.vue";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.album")
    };
  },
  components: { ExcelImport, MediaAddUpdate, draggable },
  name: "EventAlbum",
  data() {
    return {
      mediaDialog: false,
      updateForm: null,
      loading: false,
      formId: null,
      registerNewForm: false,
      timeout: null,
      excelDialog: false,
      dragList: false,
      albumSort: null,
      helpUrl: this.$helpUrl + "coupons",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx"
    };
  },
  methods: {
    async changeSort() {
      if (this.albumSort != null) clearTimeout(this.albumSort);
      this.loading = "loadingList";
      this.albumSort = setTimeout(async () => {
        var payload = [];
        this.$store.state.eventalbum.items.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveEventAlbumSort", payload);
        await this.$store.dispatch("getEventAlbum");
        this.loading = false;
      }, 500);
      this.dragList = false;
    },
    createYoutubeUrl(url) {
      var indexL = url.lastIndexOf("/");
      return url.slice(indexL + 1);
    },

    async refresh() {
      this.loading = "loadingList";
      await this.$store.dispatch("getEventAlbum");
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },
    async createRegisterForm() {
      var id = await this.$store.dispatch("createRegisterFormBase");
      this.formId = id;
      this.registerNewForm = true;
    },
    openRegisterForm(id) {
      this.formId = id;
      this.registerNewForm = true;
    },
    async deleteItem(id) {
      this.loading = id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteAlbum", id);
        this.loading = false;
      }, 500);
    },
    async statusChangedEnable(id) {
      await this.$store.dispatch("toggleRegistrationFormEnable", id);
    },
    async statusChanged(id) {
      await this.$store.dispatch("toggleRegistrationFormActive", id);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  mounted() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.$store.dispatch("getEventAlbum");
      this.loading = false;
    }, 500);
  },
  created() {},
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    registerFormList() {
      return this.$store.getters.getRegisterFormList;
    }
  }
};
</script>
<style lang="less">
.c-badge-gray {
  background-color: #eaeaea;
  font-weight: bold;
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 8px;
  align-items: center;
}
.albums-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 1rem;

  .item {
    aspect-ratio: 1;
    background-color: #fbfbfb;
    border: 0.5px solid #f1f3f6;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;

    &.passive {
      background-color: #fff2f2;
    }

    .album-drag {
      position: absolute;
      width: 100%;
      height: 100%;
      transition: all 0.5s;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-content: center;
      overflow: hidden;

      &:hover {
        background-color: rgba(41, 47, 59, 0.7);
        transition: all 0.5s;

        .album-edit {
          display: flex;
        }
      }

      span {
        width: 100%;
        text-align: center;

        i {
          font-size: 20px;
          color: white;
          font-size: 20px;
          background: #f0f8ff9e;
          padding: 2px 18px;
          border-bottom-right-radius: 14px;
          border-bottom-left-radius: 14px;
          cursor: grab;
        }

        &.album-edit {
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          display: none;

          i {
            background: #f0f8ff9e;
            color: white;
            width: 70px;
            height: 70px;
            font-size: 34px;
            cursor: pointer;
            border-radius: 50%;
            padding: 15px 10px;
            margin-top: -45px;
          }
        }
      }
    }

    & > .album-content {
      flex-grow: 1;

      .img {
        width: 100%;
        height: auto;
        aspect-ratio: 1.2;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        overflow: hidden;
      }

      iframe {
        width: 100%;
        height: auto;
        aspect-ratio: 1.2;
      }
    }
    & > .bottom {
      height: 45px;
      flex-direction: row;
      align-items: center;
      padding: 6px 10px;
      justify-content: space-between;
      display: flex;

      .album-title {
        font-size: 14px;
        color: #292f3b;
        font-weight: 600;
        line-height: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .item-2 {
    aspect-ratio: 1;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    & > .empty-content {
      border-radius: 8px;
      background-color: #f1f1f1;
      cursor: pointer;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      padding: 16px 30px;
      text-align: center;

      span {
        font-size: 14px;
        color: #292f3b;
        font-weight: 600;
        line-height: normal;
      }
      .empty-icon {
        width: 35px;
        height: 35px;
        color: white;
        font-weight: bold;
        font-size: 24px;
        background-color: #06658c;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/EventAlbum.vue